import { useState } from 'react';
import { AuthenticatorType, useRepositoryQuery } from '@mews-commander/data-access';
import { Configure2FADeviceRoute } from '../../Configure2FA/Configure2FADevice/Configure2FADevice';
import { Configure2FAPanelValidateCode } from '../Configure2FAPanelValidateCode';
import { Configure2FAPanelDeviceConfig } from './Configure2FAPanelDeviceConfig';
import { Configure2FAPanelRecoveryPins } from './Configure2FAPanelRecoveryPins';

interface Configure2FAPanelDeviceProps {
    onClose: () => void;
    onSubmit: () => void;
    onReturn: () => void;
}

export function Configure2FAPanelDevice({ onClose, onReturn, onSubmit }: Configure2FAPanelDeviceProps) {
    const [route, setRoute] = useState(Configure2FADeviceRoute.config);
    const { data: authenticator, isPending } = useRepositoryQuery(
        'users',
        'getAuthenticatorConfiguration',
        { authenticator: AuthenticatorType.Google },
        { refetchOnMount: 'always' }
    );
    const [recoveryPins, setRecoveryPins] = useState<string[]>([]);

    return (
        <>
            {route === Configure2FADeviceRoute.config && (
                <Configure2FAPanelDeviceConfig
                    authenticator={authenticator}
                    isPending={isPending}
                    onClose={onClose}
                    onReturn={onReturn}
                    onSubmit={() => setRoute(Configure2FADeviceRoute.form)}
                />
            )}
            {route === Configure2FADeviceRoute.form && (
                <Configure2FAPanelValidateCode
                    type={AuthenticatorType.Google}
                    secretKey={authenticator?.secretKey}
                    onClose={onClose}
                    onReturn={() => setRoute(Configure2FADeviceRoute.config)}
                    onSubmit={(newRecoveryPins) => {
                        setRecoveryPins(newRecoveryPins);
                        setRoute(Configure2FADeviceRoute.success);
                    }}
                />
            )}
            {route === Configure2FADeviceRoute.success && (
                <Configure2FAPanelRecoveryPins recoveryPins={recoveryPins} onClose={onSubmit} />
            )}
        </>
    );
}
